import React, { Component } from 'react'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import { siteMetadata } from '../../gatsby-config'
import {
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col,
  Button,
  Input,
  Label
} from 'reactstrap'
import Gallery from 'react-photo-gallery'
import Measure from 'react-measure'

import '../styles/portfolio.scss'

const catArr = [
  { name: 'Cervejas', folder: 'Cervejas' },
  { name: 'Águas', folder: 'Aguas' },
  { name: 'Refrescos', folder: 'Refrescos' },
  { name: 'Higiene', folder: 'Higiene' },
  { name: 'Outros', folder: 'Outros' }
]

const cat2Arr = ['Papel', 'Cut&Stack', 'Drystick', 'IML']

const cervejasImgFiles = require.context(
  '../images/Portfolio/Cervejas',
  false,
  /.*\.jpg$/
)

const cervejasArr = cervejasImgFiles.keys().map((x, i) => {
  console.log(cervejasImgFiles(x).default)
  return {
    cat: 'Cervejas',
    cat2: 'Papel',
    src: cervejasImgFiles(x).default,
    width: 1,
    height: 1
  }
})

const aguasImgFiles = require.context(
  '../images/Portfolio/Aguas',
  false,
  /.*\.jpg$/
)

const aguasArr = aguasImgFiles.keys().map((x, i) => ({
  cat: 'Águas',
  cat2: 'Cut&Stack',
  src: aguasImgFiles(x).default,
  width: 1,
  height: 1
}))

const limpezaImgFiles = require.context(
  '../images/Portfolio/Limpeza',
  false,
  /.*\.jpg$/
)

const limpezaArr = limpezaImgFiles.keys().map((x, i) => ({
  cat: 'Higiene',
  cat2: 'Cut&Stack',
  src: limpezaImgFiles(x).default,
  width: 1,
  height: 1
}))

const bebidasImgFiles = require.context(
  '../images/Portfolio/Bebidas',
  false,
  /.*\.jpg$/
)

const bebidasArr = bebidasImgFiles.keys().map((x, i) => ({
  cat: 'Refrescos',
  cat2: 'Cut&Stack',
  src: bebidasImgFiles(x).default,
  width: 1,
  height: 1
}))

const imlImgFiles = require.context(
  '../images/Portfolio/IML',
  false,
  /.*\.jpg$/
)

const imlArr = imlImgFiles.keys().map((x, i) => ({
  cat: 'Outros',
  cat2: 'IML',
  src: imlImgFiles(x).default,
  width: 1,
  height: 1
}))

const dryBImgFiles = require.context(
  '../images/Portfolio/DryB',
  false,
  /.*\.jpg$/
)

const dryBrr = dryBImgFiles.keys().map((x, i) => ({
  cat: 'Cervejas',
  cat2: 'Drystick',
  src: dryBImgFiles(x).default,
  width: 1,
  height: 1
}))

const dryImgFiles = require.context(
  '../images/Portfolio/Dry',
  false,
  /.*\.jpg$/
)

const dryArr = dryImgFiles.keys().map((x, i) => ({
  cat: 'Refrescos',
  cat2: 'Drystick',
  src: dryImgFiles(x).default,
  width: 1,
  height: 1
}))

const cutOutrosFiles = require.context(
  '../images/Portfolio/Cut_Outros',
  false,
  /.*\.jpg$/
)

const cutOutrosArr = cutOutrosFiles.keys().map((x, i) => ({
  cat: 'Outros',
  cat2: 'Cut&Stack',
  src: cutOutrosFiles(x).default,
  width: 1,
  height: 1
}))

const imlLimpFiles = require.context(
  '../images/Portfolio/IML_Limp',
  false,
  /.*\.jpg$/
)

const imlLimpArr = imlLimpFiles.keys().map((x, i) => ({
  cat: 'Higiene',
  cat2: 'IML',
  src: imlLimpFiles(x).default,
  width: 1,
  height: 1
}))

const imgArr = [].concat(
  cervejasArr,
  aguasArr,
  limpezaArr,
  bebidasArr,
  imlArr,
  dryBrr,
  dryArr,
  cutOutrosArr,
  imlLimpArr
)

export default class PortifolioPage extends Component {
  constructor (props) {
    super(props)
    const urlHash = props.location.hash.replace('#', '')
    const isInCat = []
      .concat(catArr, cat2Arr)
      .find(value => value.folder === urlHash || value === urlHash)
    const selected =
      isInCat !== undefined
        ? isInCat.name !== undefined
          ? isInCat.name
          : isInCat
        : null
    const filteredArr =
      selected != null
        ? imgArr.filter(img => img.cat === selected || img.cat2 === selected)
        : null
    this.state = { width: -1, selected, filteredArr }
  }

  _onClickCat (cat) {
    if (cat === 'Todos') {
      this.setState({ selected: null, filteredArr: null })
    } else {
      const filteredArr1 = imgArr.filter(img => img.cat === cat)
      const filteredArr2 = imgArr.filter(img => img.cat2 === cat)
      const filteredArr = [].concat(filteredArr1, filteredArr2)
      this.setState({ selected: cat, filteredArr })
    }
  }

  _renderFilter () {
    // eslint-disable-next-line no-unused-vars
    const { width, filteredArr, selected } = this.state
    if (width >= 992) {
      return (
        <Nav
          justified
          style={{ backgroundColor: '#f8f8f8' }}
          className="p-2 rounded-top"
        >
          <NavItem>
            <NavLink
              href="#"
              onClick={() => this._onClickCat('Todos')}
              active={selected === null}
            >
              Todos
            </NavLink>
          </NavItem>
          {catArr &&
            catArr.map(cat => (
              <NavItem key={cat.folder}>
                <NavLink
                  href="#"
                  onClick={() => this._onClickCat(cat.name)}
                  active={selected === cat.name}
                >
                  {cat.name}
                </NavLink>
              </NavItem>
            ))}
          {cat2Arr &&
            cat2Arr.map(cat => (
              <NavItem key={cat}>
                <NavLink
                  href="#"
                  onClick={() => this._onClickCat(cat)}
                  active={selected === cat}
                >
                  {cat}
                </NavLink>
              </NavItem>
            ))}
        </Nav>
      )
    } else {
      return (
        <div className="m-3">
          <Label for="catSelect">Escolha a categoria</Label>
          <Input
            type="select"
            name="catSelect"
            id="catSelect"
            onChange={event => this._onClickCat(event.target.value)}
          >
            <option selected={selected === null}>Todos</option>
            {catArr &&
              catArr.map(cat => (
                <option selected={selected === cat.name}>{cat.name}</option>
              ))}
            {cat2Arr &&
              cat2Arr.map(cat => (
                <option selected={selected === cat}>{cat}</option>
              ))}
          </Input>
        </div>
      )
    }
  }

  render () {
    const { width, filteredArr } = this.state
    return (
      <div>
        <Helmet
          title={`${get(siteMetadata, 'title')} - Portfolio`}
          meta={[
            { name: 'author', content: get(siteMetadata, 'author') },
            {
              name: 'description',
              content:
                'Conheça os clientes e o portfolio de rótulos Savasa Impressores.'
            },
            {
              name: 'keywords',
              content:
                'Savasa, Cervejas, Águas, Refrescos, Higiene, rótulos, Papel, Cut Stack, Drystick, IML'
            },
            { property: 'og:title', content: get(siteMetadata, 'title') },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:description',
              content:
                'Conheça os clientes e o portfolio de rótulos Savasa Impressores.'
            },
            {
              property: 'og:url',
              content: `${get(siteMetadata, 'siteUrl')}`
            },
            {
              property: 'og:image',
              content: `${get(
                siteMetadata,
                'siteUrl'
              )}/favicon/android-icon-512x512.png`
            }
          ]}
        />
        <Container className="py-1">
          <h2
            className="my-5 text-center fc-E66827"
            style={{ letterSpacing: '10px' }}
          >
            PORTFOLIO
          </h2>
        </Container>
        <Container>{this._renderFilter()}</Container>
        <Measure
          bounds
          onResize={contentRect =>
            this.setState({ width: contentRect.bounds.width })
          }
        >
          {({ measureRef }) => {
            if (width < 1) {
              return <div ref={measureRef} />
            }
            let columns = 1
            if (width >= 500) {
              columns = 2
            }
            if (width >= 700) {
              columns = 3
            }
            if (width >= 1000) {
              columns = 4
            }
            if (width >= 1450) {
              columns = 5
            }

            if (
              filteredArr != null &&
              filteredArr.length === 1 &&
              width >= 600
            ) {
              columns = 2
            }

            console.log('alooow', imgArr)

            return (
              <div ref={measureRef}>
                <Gallery
                  photos={filteredArr || imgArr}
                  columns={columns}
                  margin={0}
                />
              </div>
            )
          }}
        </Measure>
        {/* <Container
          style={{
            backgroundColor: '#f8f8f8',
            height: '56px',
            marginBottom: '5px',
          }}
          className="p-2 rounded-bottom"
        /> */}

        <div className="bg-F59432 mt-5">
          <Container>
            <Row className="text-center py-3">
              <Col xs="12" className="p-3 text-right">
                <Button
                  href="/orcamento"
                  outline
                  color="secondary"
                  size="lg"
                  block
                >
                  SOLICITE UM ORÇAMENTO
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    )
  }
}
